import { useEffect, useState } from "react";
import Url from '../LocalService';
import { useFetchServices } from "../hooks/useFetchServices";

export const Actions = ({endpoint}) => {
    let [dto, setDto] = useState([]);
    let [dtoLength, setDtoLength] = useState(null);    
    let fetchservices = useFetchServices();

    const loadDto = () =>{      
      /*
      fetch(Url + "dashboard."+endpoint+".php")
      .then((res) => {
        return res.json();
      })
      */
      fetchservices.executeService({method:"GET", endpoint:"dashboard."+endpoint+".php", body:{request:endpoint}})
      .then((data) => {
        if (data.success) {   
            setDto(data.data);
            setDtoLength(true);  
        } else {
            setDtoLength(0);
        }
      })
      .catch((err) => {
        console.log(err);
      });
    };

    useEffect(() => {
        loadDto();
    }, []);

    return {
        dto,
        dtoLength,
    };

};
